export const MapConfig = {
  zoom: 2,
  center: [12, 64],

  inernwebMapExtent: {
    xmin: -915020.1799341175,
    ymin: 6373074.350009031,
    xmax: 1564024.778155799,
    ymax: 7833407.937342872,
    spatialReference: {
      wkid: 32633,
    },
  },

  kundewebMapExtent: {
    xmin: -392943.35479620297,
    ymin: 6363722.055130746,
    xmax: 1137833.0400899202,
    ymax: 7918882.498784967,
    spatialReference: {
      wkid: 32633,
    },
  },

  vectorTileLayerUrl:
    "https://services.geodataonline.no/arcgis/rest/services/GeocacheVector/GeocacheBasis_WGS84/VectorTileServer/",

  kspuLayerUrl:
    "https://gisportal.puma.posten.no/arcgis/sharing/servers/09061d3c870a41df9c5537f1d082a45a/rest/services/KSPU/MapServer",

  kundewebLayerUrl:
    "https://gisportal.puma.posten.no/arcgis/sharing/servers/b3186676b9674781b1ab2e563702fa75/rest/services/PumaKundeweb/MapServer",

  geoKodingUrl:
    "https://gisportal.puma.posten.no/arcgis/sharing/servers/c7f4151c81e048d8969ab43dfc606c3f/rest/services/Geokoding/GeocodeServer",

  geoSokUrl:
    "https://gisportal.puma.posten.no/arcgis/sharing/servers/c7f4151c81e048d8969ab43dfc606c3f/rest/services/Geokoding/GeocodeServer",

  driveTimeAnalysisUrl:
    "https://gisportal.puma.posten.no/arcgis/sharing/servers/de1f05e93a554ddaab1f0b2ed39d3f4d/rest/services/DriveTime/GPServer",

  oldUtvalgGeometryUrl:
    "https://gisportal.puma.posten.no/arcgis/sharing/servers/888e431ea4924d9baeee9a7444f688a4/rest/services/OldUtvalgGeometry/MapServer/0",

  budruterOutField: [
    "reolnavn",
    "reolnr",
    "beskrivelse",
    "kommentar",
    "reol_id",
    "kommuneid",
    "kommune",
    "fylkeid",
    "fylke",
    "teamnr",
    "teamnavn",
    "postnr",
    "poststed",
    "segment",
    "hh",
    "hh_res",
    "gb",
    "gb_res",
    "er",
    "er_res",
    "vh",
    "p_hh_u_res",
    "np_hh_u_res",
    "p_vh_u_res",
    "np_vh_u_res",
    "prissone",
    "reoltype",
    "pbkontnavn",
    "prsnr",
    "prsnavn",
    "prsbeskrivelse",
    "rutedistfreq",
    "sondagflag",
  ],
};
